import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, MailCheck } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { inputCls, btnPrimary } from "@/components/Form";
import AuthCard from "@/components/AuthCard";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await api.post("/auth/forgot-password", { email }); setSent(data.message); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <AuthCard eyebrow="Recuperar acesso" title="Esqueci minha senha" desc="Informe o e-mail da sua conta e enviaremos um link para criar uma nova senha.">
      {sent ? (
        <div className="flex gap-3 rounded-xl bg-emerald-50 p-4 text-sm text-emerald-800" data-testid="forgot-sent-msg"><MailCheck className="h-5 w-5 shrink-0" />{sent}</div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="forgot-email-input" required type="email" placeholder="E-mail" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} />
          <button data-testid="forgot-submit-btn" disabled={busy} className={`${btnPrimary} w-full`}>{busy && <Loader2 className="h-4 w-4 animate-spin" />}Enviar link</button>
        </form>
      )}
      <p className="mt-6 text-center text-sm"><Link to="/login" data-testid="back-to-login-link" className="font-semibold text-amber-700 hover:underline">Voltar para o login</Link></p>
    </AuthCard>
  );
}
